import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidArrowUpIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Zm.5833-14.752 4.1667 4.1322c.3333.3305.3333.9091 0 1.2396-.3333.3306-.8333.3306-1.1667 0l-2.75-2.7272v6.281c0 .4958-.3333.8264-.8333.8264s-.8333-.3306-.8333-.8264v-6.281l-2.75 2.6446c-.3334.3306-.8334.3306-1.1667 0-.3333-.3306-.3333-.8265 0-1.157l4.1667-4.1323c.3333-.3305.8333-.3305 1.1666 0Z" clipRule="evenodd"/>
  </SvgIcon>
}

export default SolidArrowUpIcon
